<template>
    <Head title="Update Admin User"/>
        <BreezeAuthenticatedLayout>
            <template #header>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Update Admin User - {{ user.name }}
                </h2>
            </template>
            <BreadCrumbs :items="navItems"></BreadCrumbs>
            <div class="w-full my-6 overflow-hidden py-12 shadow">
                <div class="px-6 pt-4 pb-2">
                    <form enctype="multipart/form-data" @submit.prevent="submit" class="w-full">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="mb-6 md:mb-4">
                                <admin-app-label>Name</admin-app-label>
                                <input-basic
                                    placeholder="Name"
                                    v-model="form.name"
                                    :error="errors['name']"
                                />
                                <input-error v-if="errors['name']">
                                    {{ errors.name }}
                                </input-error>
                            </div>
                            <div class="mb-6 md:mb-4">
                                <admin-app-label>Email Address</admin-app-label>
                                <input-basic
                                    placeholder="Email Address"
                                    v-model="form.email"
                                    :error="errors['email']"
                                />
                                <input-error v-if="errors['email']">
                                    {{ errors.email }}
                                </input-error>
                            </div>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="mb-6 md:mb-4">
                                <admin-app-label>Password</admin-app-label>
                                <input-basic
                                    type="password"
                                    placeholder="Password"
                                    v-model="form.password"
                                    :error="errors['password']"
                                />
                                <input-error v-if="errors['password']">
                                    {{ errors.password }}
                                </input-error>
                            </div>
                            <div class="mb-6 md:mb-4">
                                <admin-app-label>Confirm Password</admin-app-label>
                                <input-basic
                                    type="password"
                                    placeholder="Confirm Password"
                                    v-model="form.password_confirmation"
                                    :error="errors['password_confirmation']"
                                />
                                <input-error v-if="errors['password_confirmation']">
                                    {{ errors.password_confirmation }}
                                </input-error>
                            </div>
                        </div>

                        <seo-tags v-model="form.seo_tags" :errors="errors"></seo-tags>
                        <app-button type="submit" :disabled="form.processing" class="mt-8">Update</app-button>
                    </form>
                </div>
            </div>
        </BreezeAuthenticatedLayout>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import {Head} from "@inertiajs/inertia-vue3";
import Label from "@/Components/Label";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import AppButton from "@/Components/AppButton";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";

export default {
    name: "Edit",
    components: {
        BreadCrumbs,
        AdminAppLabel,
        AppButton,
        InputBasic,
        Label,
        BreezeAuthenticatedLayout,
        Head,
        InputError
    },
    props: {
        name: String,
        user: Object,
        errors: Object,
    },
    data() {
        return {
            navItems: [
                {title: "Users", path: "/admin/users"},
            ],
            form: this.$inertia.form({
                ...this.user,
                password: "",
                password_confirmation: "",
                _method: "put",
            }),
        }
    },
    mounted() {
        this.navItems.push({
            title: this.user.name,
            path: this.route("admin.users.edit", this.user)
        });
    },
    methods: {
        submit()
        {
            this.form.post(`/admin/users/${this.user.id}`);
        }
    }
}
</script>

<style scoped>

</style>
